import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { IMicrositeRecipientLinkedEntityList } from '@nkr/models/microsites/microsite-recipient-linked-entity';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { RowNumberRenderer } from './renderers';

interface IProps {
    list: IMicrositeRecipientLinkedEntityList[],
    onGridReady: (e: GridReadyEvent) => void
}

const MicrositeLinkedEntitiesList: React.FC<IProps> = (props) => {
    const columns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: '#',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>#</SortableHeaderComponent>,
            width: 50,
            cellClass: 'microsite-list-cell',
            headerClass: 'microsite-list-header',
            sortable: false,
            cellRendererFramework: RowNumberRenderer,
            suppressSizeToFit: true
        },
        {
            colId: 'type',
            field: 'type',
            headerName: 'Type',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Type</SortableHeaderComponent>,
            width: 140,
            cellClass: 'microsite-list-cell',
            headerClass: 'microsite-list-header',
            sortable: true
        },
        {
            colId: 'recpAlias',
            field: 'recpAlias',
            headerName: 'RecipientAlias',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
            width: 140,
            cellClass: 'microsite-list-cell',
            headerClass: 'microsite-list-header',
            sortable: true,cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IMicrositeRecipientLinkedEntityList;

                if (data.type == 'DSD') {
                    return (
                        <a href={`center/${data.centerId}/donors/donor-shield-direct/edit-donor/${data.entityId}`} target='_blank'>
                            {data.recpAlias}
                        </a>
                    );                   
                } else {
                    return (
                        <a href={`center/${data.centerId}/recipient/${data.entityId}/profile/general`} target='_blank'>
                            {data.recpAlias}
                        </a>
                    );
                }

                return <>{params.data.name}</>;
            }
        }
    ];

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
        props.onGridReady(e);
    }

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <AgGridReact
                columnDefs={columns}
                rowData={props.list}
                headerHeight={45}
                groupHeaderHeight={30}
                rowHeight={28}
                suppressCellSelection={true}
                immutableData={true}
                getRowNodeId={(data: IMicrositeRecipientLinkedEntityList) => data.entityId.toString()}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                suppressContextMenu={true}
                domLayout='autoHeight'
            />
        </div>
    );
}

export default MicrositeLinkedEntitiesList;